import {
  type ScorableMetric,
  isAccountStatusMetric,
  isCustomFieldMetric,
  isRatioId,
  isWorkflowStageMetric,
  isWorkflowStageMetricV2,
} from '@terros/common'
import { type ScorableMetricForForm } from './types'

export const toScorable = (formScorable: ScorableMetricForForm): ScorableMetric | undefined => {
  const { field, name } = formScorable
  if (!field) return

  const type = 'exists' as const
  if (field === 'contact.pitch' || field === 'contact.pitches') return { name, field, type }
  if (field === 'contact.daysWorked') return { name, field, type }
  if (field === 'meeting.checkin' || field === 'meetingAttendance.count') return { name, field, type }
  if (field === 'conversation.averageScore' || field === 'conversation.count' || field === 'conversation.activeHours')
    return { name, field, type }
  if (isAccountStatusMetric(field)) return { name, field, type }
  if (isCustomFieldMetric(field)) return { name, field, type }
  if (isRatioId(field)) return { name, field, type }
  if (isWorkflowStageMetric(field)) return { name, field, type }
  if (isWorkflowStageMetricV2(field)) return { name, field, type }
}
